/**
 * Present a dialog asking the user to confirm that they
 * want to remove their credit card information.
 */
import Radio from 'backbone.radio';
import RemovePaymentDialogView from '@/views/dialogs/remove_payment';

var globalCh = Radio.channel('global');
function show_remove_payment_dialog(payment_data) {
    var dialog = new RemovePaymentDialogView({
        payment_data: payment_data
    });

    globalCh.request('showDialog', dialog);
}
export default show_remove_payment_dialog;

